import { render, staticRenderFns } from "./assetsStatistics.vue?vue&type=template&id=1115c6bd&scoped=true"
import script from "./assetsStatistics.vue?vue&type=script&lang=js"
export * from "./assetsStatistics.vue?vue&type=script&lang=js"
import style0 from "./assetsStatistics.vue?vue&type=style&index=0&id=1115c6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115c6bd",
  null
  
)

export default component.exports